module.exports = __webpack_public_path__ + "static/media/Avenir-Medium.8493a6ce.woff";